<script setup lang="ts">
import type { PropertyColor, PropertySize } from "~/classes/generated/interface"

import { PropertyId, PropertySchema } from "~/classes/entity"

const props = defineProps({
  file: null,
  propertyId: null,
  size: null,
  color: null,
  selected: { type: Boolean }
})
const { viewModePropertySizes, viewModePropertyColors } = useViewMode()

function dimensions() {
  const wProp = props.file.property(PropertyId.MEDIA_WIDTH_PX)
  if (!wProp || wProp.value.type !== PropertySchema.PositiveIntegerValue)
    return ""
  const width = wProp.value.positiveInteger

  const hProp = props.file.property(PropertyId.MEDIA_HEIGHT_PX)
  if (!hProp || hProp.value.type !== PropertySchema.PositiveIntegerValue)
    return ""
  const height = hProp.value.positiveInteger
  return `${width} x ${height}`
}
</script>

<template>
  <span
    :data-property-id="propertyId"
    :class="{
      [viewModePropertySizes[size].textCss]: true,
      [viewModePropertyColors[color].textCss]: !selected,
    }"
  >
    {{ dimensions() }}
  </span>
</template>
